// src/utils/mapsLoader.js
let loadPromise = null;

function getApiKey() {
  // CORRECCIÓN: Clave API inyectada directamente
  return "AIzaSyDesSk3U-V2c7qDDqn_jQ_FcxQvtc_aa2Q"; 
}

export async function loadGoogleMaps() {
  // Caso 1: Maps ya está cargado y Places también
  if (window.google?.maps && window.google?.maps?.places) {
    return;
  }

  // Si Maps está cargado, pero Places no (forma moderna con importLibrary)
  if (window.google?.maps && window.google.maps.importLibrary) {
    try { 
      // Intentamos cargar Places si ya tenemos el script base
      await window.google.maps.importLibrary("places"); 
    } catch (e) {
      console.error("[mapsLoader] Falló importLibrary('places')", e);
    }
    return;
  }

  // Caso 3: Iniciar la carga desde cero
  if (!loadPromise) {
    const apiKey = getApiKey();
    if (!apiKey) {
      console.error("[mapsLoader] Falta API key.");
      // Rechazamos la promesa si no hay clave, aunque ya la inyectamos, por seguridad.
      return Promise.reject(new Error("API Key missing."));
    }

    loadPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector("#gmaps-script");
      if (existing) {
        // Manejo de script que ya está inyectado
        existing.addEventListener("load", async () => {
          try { 
            if (window.google?.maps?.importLibrary) await window.google.maps.importLibrary("places"); 
          } catch {}
          resolve();
        }, { once: true });
        existing.addEventListener("error", reject, { once: true });
        return;
      }

      const params = new URLSearchParams({
        key: apiKey,
        v: "weekly",
        // CLAVE: Eliminamos 'libraries: "places"' de la URL inicial para usar importLibrary.
      });

      const s = document.createElement("script");
      s.id = "gmaps-script";
      s.async = true;
      s.defer = true;
      s.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
      s.onload = async () => {
        try {
          // Cargamos la librería Places DESPUÉS de que el script base termine.
          if (window.google?.maps?.importLibrary) {
            await window.google.maps.importLibrary("places");
          }
        } catch {}
        resolve(); // Resolvemos la promesa solo cuando Places está cargado (o se intentó)
      };
      s.onerror = (e) => {
        console.error("[mapsLoader] Error cargando Google Maps JS", e);
        reject(e);
      };
      document.head.appendChild(s);
    });
  }

  return loadPromise;
}